/**
 * @module Core
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomErrorHandler } from '@core/error-handler/services/error.handler';
import { HttpEventInterceptorService } from '@core/error-handler/services/http-event-interceptor.service';

/**
 * The ErrorHandlerModule module provides services to capture global errors and handle them
 * all Http requests error if not handled will handle by this module
 * @access private -- only imported by Core
 */
@NgModule({
  imports: [CommonModule],
  providers: [HttpEventInterceptorService, { provide: ErrorHandler, useClass: CustomErrorHandler }],
  declarations: [],
})
export class ErrorHandlerModule {}
